import { getScreenshotServerUrl } from '../models/Application';

const screenshotsServerHealthUrl = screenshotServerUrl =>
  (screenshotServerUrl || getScreenshotServerUrl()) + 'health';

const checkHealth = async screenshotServerUrl => {
  try {
    const response = await window.fetch(
      screenshotsServerHealthUrl(screenshotServerUrl)
    );

    if (response.ok) {
      return;
    } else {
      throw new Error(
        `Screenshot server healthcheck failed with status: ${response.status}`
      );
    }
  } catch (error) {
    if (error instanceof TypeError) {
      throw new Error(`Screenshot healthcheck failed - ${error.message}`);
    }
    throw error;
  }
};

export default checkHealth;
